import { styled } from '@mui/material';

import IconButton from './IconButton';

const ToolbarIconButton = styled(IconButton)(({ theme }) => ({
  padding: theme.spacing(0.1),
}));

export default ToolbarIconButton;
